import { render, staticRenderFns } from "./Pascabayar.vue?vue&type=template&id=18ee3c34&"
import script from "./Pascabayar.vue?vue&type=script&lang=js&"
export * from "./Pascabayar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports